import React from "react";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { useDispatch } from "react-redux";
import { deleteUserHomeBase } from "Bands/state";

const { userHomeBase: baseCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserHomeBaseModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserHomeBase(id));
  };

  return (
    <DeleteUserEntityModal
      type="home base"
      action={USER_ACTIONS.deleteUserHomeBase}
      successMessage={baseCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
